export default {
    methods: {
        requestQiniuToken_2(_suffix, _then) {
          var _this = this;

          sdk.QiniuApi().qiniuToken({
            suffix : _suffix
          }).then(resp => {
            _this.token = resp;
            _this.uploaderDomain = resp.domain;

            _then(_this.token);
          });
        },

        uploadToQiniu_2(_file, _token, _then) {
            if ( !_file ) {
              console.log('#18 uploadToQiniu_2 error, _file=', _file, ', _token=', _token);
              return;
            }

            var _this = this;

            var url = "//upload-z0.qiniup.com";

            var formData = new FormData();
            formData.append("file", _file);
            formData.append("key", _token.key);
            formData.append("token", _token.token);

            this.$http.post(url, formData).then(resp => {
                var _attachment = {
                    fileName: _file.name,
                    filePath: _this.uploaderDomain + "/" + resp.data.key
                };

                if ( !_attachment.fileName ) {
                  _attachment.fileName = resp.data.key;
                }

                if ( !!_then ) {
                    _then( _attachment );
                }
            });
        }
    }
  }



// WEBPACK FOOTER //
// ./src/assets/mixins/AbstractQiniuUploader.js